import type { CSSProperties } from 'react'
import { MaterialSymbolProps } from './index'

export function getFontVariationSettings(
  fill?: boolean,
  weight?: MaterialSymbolProps['weight'],
  grade?: number,
  opticalSize?: number
) {
  let style: CSSProperties = {}
  if (fill) style.fontVariationSettings = [style.fontVariationSettings, "'FILL' 1"].filter(Boolean).join(', ')
  if (weight) style.fontVariationSettings = [style.fontVariationSettings, `"wght" ${weight}`].filter(Boolean).join(', ')
  if (grade) style.fontVariationSettings = [style.fontVariationSettings, `"GRAD" ${grade}`].filter(Boolean).join(', ')
  if (opticalSize) {
    style.fontVariationSettings = [style.fontVariationSettings, `"opsz" ${opticalSize}`].filter(Boolean).join(', ')
    style.fontSize = opticalSize
  }

  return style
}

export function getOpticalSizeBasedOnIconSize(iconSize: MaterialSymbolProps['size']) {
  switch (iconSize) {
    case 'xSmall':
      return 16
    case 'small':
      return 20
    case 'medium':
      return 24
    case 'large':
      return 40
    case 'xLarge':
      return 48
    default:
      return 24 // medium
  }
}
